module.exports = __webpack_public_path__ + "img/huayang.3baa2176.jpg";